import * as ng from 'angular';


class ViewDocIdConserveModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];
  private close: any;

  constructor(
    private $scope: {
      documentsId: string[];
      [key: string]: any
    },
    private $rootScope: any,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {
    $scope.documentsId = $scope.$parent.$resolve.documentsId.toString().split(',');

    $scope.close = () => {
      this.close({$value: false});
    };
  }
}


export const ViewDocIdDocumentModalComponent: ng.IComponentOptions = {

  template: require('./view-doc-conserve-modal.html'),
  controller: ViewDocIdConserveModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/view-doc-conserve-modal/view-doc-conserve-modal.ts